module.exports = __webpack_public_path__ + "static/media/kobie-lg.ea255a8a.jpg";